export const STORAGE_KEYS = {
	TOKEN: "served:staff:token",
	REFRESH_TOKEN: "served:staff:refreshToken",
	DENOMINATOR: "served:staff:denominator",
	VENUE_ID: "served:staff:venueId",
	PREFERRED_LOCATION: "served:staff:preferredLocation",
	PREFERRED_LOCATION_VIEW: "served:staff:preferredLocationView",
	FLOORPLAN_VIEWPORT: "served:staff:floorplanViewport",
	PREFERRED_CALENDAR_VIEW: "served:staff:preferredCalendarView",
	PREFERRED_LOCATION_ON_TILL: "served:staff:preferredLocationOnTill",
	TILL_MASTER_ITEM_FILTER_BY_CATEGORY:
		"served:staff:tillMasterItemFilterByCategory",
	TILL_STATES: "served:staff:tillStates",
	LANGUAGE: "served:staff:language",
	KPAY_TERMINAL_IP: "served:staff:kpayTerminalIp",
	SELECTED_RECEIPT_PRINTER: "served:staff:selectedReceiptPrinter",
	LAST_OFFLINE_DATA_DOWNLOAD_AT: "served:staff:lastOfflineDataDownloadAt",
	OFFLINE_MUTATIONS: "served:staff:offlineMutations",
	OFFLINE_ACCESSIBLE_LOCATION_IDS: "served:staff:offlineAccessibleLocationIds",
	DIGITAL_MENU_NOTIFICATION_LOCATION_IDS:
		"served:staff:digitalMenuNotificationLocationIds",
	LAST_LOGGED_IN_ROLE_ID: "served:staff:lastLoggedInRoleId",
	DRAWER_OPEN: "served:staff:drawerOpen",
	DRAWER_PERSISTENT: "served:staff:drawerPersistent",
} as const;
